import 'reflect-metadata';

import { Container } from 'inversify';
import { UserProfileService } from './implementation/UserProfileService';
import { MockUserProfileService } from './implementation/MockUserProfileService';
import { CustomerService } from './implementation/CustomerService';
import { MockCustomerService } from './implementation/MockCustomerService';
import { CoreDataService } from './implementation/CoreDataService';
import { FirebaseCloudMessagingService } from './implementation/FirebaseCloudMessagingService';
import { MockFirebaseCloudMessagingService } from './implementation/MockFirebaseCloudMessagingService';
import { NotificationService } from './implementation/NotificationService';
import { MockNotificationService } from './implementation/MockNotificationService';
import { FileHandlerService } from './implementation/FileHandlerService';
import { MockFileHandlerService } from './implementation/MockFileHandlerService';
import { HttpWrapperService } from './HttpWrapperService';
import { ServiceConfig } from './config/serviceConfig';
import { PartnerMasterService } from './implementation/PartnerMaster';
import { WebhookService } from './implementation/WebhookService';
import { MasterDataService } from './implementation/MasterDataService';
import { MockMasterDataService } from './implementation/MockMasterDataService';

const TYPES = {
  IUserProfileService: Symbol.for('IUserProfileService'),
  ICustomerService: Symbol.for('ICustomerService'),
  ICoreDataService: Symbol.for('ICoreDataService'),
  IHttpWrapperService: Symbol.for('IHttpWrapperService'),
  IFirebaseCloudMessagingService: Symbol.for('IFirebaseCloudMessagingService'),
  INotificationService: Symbol.for('INotificationService'),
  IFileHandlerService: Symbol.for('IFileHandlerService'),
  IPartnerMasterService: Symbol.for('IPartnerMasterService'),
  IWebhookService: Symbol.for('IWebhookService'),
  IMasterDataService: Symbol.for('IMasterDataService'),
};

const container = new Container();

// Conditionally bind mock or real user profile service based on configuration
if (ServiceConfig.USE_MOCK_SERVICES) {
  container.bind(TYPES.IUserProfileService).to(MockUserProfileService).inSingletonScope();
} else {
  container.bind(TYPES.IUserProfileService).to(UserProfileService).inSingletonScope();
}

container.bind(TYPES.IPartnerMasterService).to(PartnerMasterService).inSingletonScope();

// Conditionally bind mock or real customer service based on configuration
if (ServiceConfig.USE_MOCK_SERVICES) {
  container.bind(TYPES.ICustomerService).to(MockCustomerService).inSingletonScope();
} else {
  container.bind(TYPES.ICustomerService).to(CustomerService).inSingletonScope();
}

// Bind Core Data Service (no mock version yet)
container.bind(TYPES.ICoreDataService).to(CoreDataService).inSingletonScope();

// Conditionally bind mock or real Firebase Cloud Messaging service based on configuration
if (ServiceConfig.USE_MOCK_SERVICES) {
  container.bind(TYPES.IFirebaseCloudMessagingService).to(MockFirebaseCloudMessagingService).inSingletonScope();
} else {
  container.bind(TYPES.IFirebaseCloudMessagingService).to(FirebaseCloudMessagingService).inSingletonScope();
}

// Conditionally bind mock or real notification service based on configuration
if (ServiceConfig.USE_MOCK_SERVICES) {
  container.bind(TYPES.INotificationService).to(MockNotificationService).inSingletonScope();
} else {
  container.bind(TYPES.INotificationService).to(NotificationService).inSingletonScope();
}

container.bind(TYPES.IHttpWrapperService).to(HttpWrapperService).inSingletonScope();

// Conditionally bind mock or real file handler service based on configuration
if (ServiceConfig.USE_MOCK_SERVICES) {
  container.bind(TYPES.IFileHandlerService).to(MockFileHandlerService).inSingletonScope();
} else {
  container.bind(TYPES.IFileHandlerService).to(FileHandlerService).inSingletonScope();
}

// Conditionally bind mock or real master data service based on configuration
if (ServiceConfig.USE_MOCK_SERVICES) {
  container.bind(TYPES.IMasterDataService).to(MockMasterDataService).inSingletonScope();
} else {
  container.bind(TYPES.IMasterDataService).to(MasterDataService).inSingletonScope();
}

// Bind Webhook Service
container.bind(TYPES.IWebhookService).to(WebhookService).inSingletonScope();

export { container, TYPES };
